<template>
    <div class=''>
        <div class="mini_content continer_width m_100" >
            <el-row type="flex" :gutter="20" justify="space-between">
              <!-- 左侧菜单栏 -->
                <el-col :span="10" class="left">
                    <el-collapse v-model="exchangeTab" @change="handleChange" accordion>
                        <el-collapse-item :class="{ aaa: currentActiveName == '1' }" :title="$t('exchange.CarbonTrading')" name="1">
                        </el-collapse-item>
                        <el-collapse-item :class="{ aaa: currentActiveName == '2' }" :title="$t('exchange.OrderHistory')" name="2">
                        </el-collapse-item>
                        <el-collapse-item :class="{ aaa: currentActiveName == '3' }" :title="$t('exchange.TradeHistory')" name="3">
                        </el-collapse-item>
                    </el-collapse>
                </el-col>

              <!-- 右侧内容区 -->
                <el-col>

                  <!-- CarbonTrading买卖CNT -->
                    <div v-if="currentActiveName == '1'">
                        <div class="overview_wrap">

                            <!-- 顶部价格信息 -->
                            <el-row type="flex" :gutter="60" justify="space-between">
                                <el-col>
                                    <el-row type="flex" :gutter="20" justify="space-between">
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title">{{$t('exchange.OpenPrice')}}</div>
                                                <div class="carbon_box_ipt">$1,233.30</div>
                                            </div>
                                        </el-col>
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title">{{$t('exchange.LastPrice')}}</div>
                                                <div class="carbon_box_ipt">$1,234.56</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col>
                                    <el-row type="flex" :gutter="20" justify="space-between">
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title">{{$t('exchange.LowPrice')}}</div>
                                                <div class="carbon_box_ipt">$1,195.55</div>
                                            </div>
                                        </el-col>
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title">{{$t('exchange.HighPrice')}}</div>
                                                <div class="carbon_box_ipt">$1,244.06</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>

                            <!-- 买卖信息 -->
                            <el-row type="flex" class="mg_top" :gutter="60" justify="space-between">
                                <el-col>
                                    <el-row type="flex" :gutter="20" justify="space-between">
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title green_text">{{$t('exchange.BuyPrice')}}</div>
                                                <div class="carbon_box_ipt">{{addComma(buyPrice)}}</div>
                                            </div>
                                        </el-col>
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title green_text">{{$t('exchange.BuyAmount')}}</div>
                                                <div class="carbon_box_ipt">{{addComma(buyAmount)}}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col>
                                    <el-row type="flex" :gutter="20" justify="space-between">
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title red_text">{{$t('exchange.SellPrice')}}</div>
                                                <div class="carbon_box_ipt">{{addComma(sellPrice)}}</div>
                                            </div>
                                        </el-col>
                                        <el-col>
                                            <div class="carbon_box">
                                                <div class="carbon_box_title red_text">{{$t('exchange.SellAmount')}}</div>
                                                <div class="carbon_box_ipt">{{addComma(sellAmount)}}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>

                            <!-- 买卖操作 -->
                            <el-row type="flex" class="mg_top"  :gutter="20" justify="space-between">
                                <!-- order按钮 -->
                                <el-col>
                                    <div class="carbon_box">
                                        <div class="carbon_box_title">{{$t('exchange.Order')}}</div>
                                        <div class="carbon_btn">
                                            <div class="btn_box" :class="btntype == 'buy' ? 'buy_btn' : ''" @click="buyorsell('buy')">{{$t('exchange.Buy')}}</div>
                                            <div class="btn_box" :class="btntype == 'sell' ? 'sell_btn' : ''" @click="buyorsell('sell')">{{$t('exchange.Sell')}}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <!-- amount输入 -->
                                <el-col>
                                    <div class="carbon_box">
                                        <div class="carbon_box_title">{{$t('exchange.Amount')}}</div>
                                        <div class="carbon_btn">
                                            <el-input placeholder=""  v-model="amount" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                                                <template slot="append">CNT</template>
                                            </el-input>
                                            <div class="ch_txt">X</div>
                                        </div>
                                    </div>
                                </el-col>
                                <!-- 价格输入 -->
                                <el-col>
                                    <div class="carbon_box">
                                        <div class="carbon_box_title">{{$t('exchange.LimitPrice')}}</div>
                                        <div class="carbon_btn">
                                            <el-input placeholder="" v-model="limitPrice" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                                                <template slot="append">USD</template>
                                            </el-input>
                                        </div>
                                    </div>
                                </el-col>
                                <!-- type选择 -->
                                <el-col>
                                    <div class="carbon_box">
                                        <div class="carbon_box_title">{{$t('exchange.OrderType')}}</div>
                                        <div class="carbon_btn">
                                            <el-select v-model="orderType" placeholder="">
                                                <el-option
                                                    v-for="item in orderTypeList"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <div class="ch_txt">=</div>
                                        </div>
                                    </div>
                                </el-col>
                                <!-- 总价格计算 -->
                                <el-col>
                                    <div class="carbon_box">
                                        <div class="carbon_box_title">{{$t('exchange.LimitPrice')}}</div>
                                        <div class="carbon_btn">
                                            <el-input placeholder="" disabled v-model="limitPriceAmount" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                                                <template slot="append">USD</template>
                                            </el-input>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>

                            <!-- 计算 -->
                            <el-row type="flex" class="mg_top" justify="space-between">
                                <el-col :span="6">
                                    <div>
                                        <el-checkbox v-model="checked">{{$t('exchange.Skiporderconfirmations')}}</el-checkbox>
                                    </div>
                                </el-col>
                                <el-col :span="5">
                                    <div @click="submitBuyCnt()" :class="btntype == 'sell' ? 'sell_btn' : ''" class="btn_box_mg">{{btntype == 'sell' ? 'Sell CNT with USD' : $t('exchange.BuyCNTwithUSD')}}</div>
                                </el-col>
                            </el-row>

                        </div>
                    </div>

                    <!-- OrderHistory列表 -->
                    <div v-if="currentActiveName == '2'">
                        <div class="">
                            <el-table :data="orderHistoryList.slice( (currentPage - 1) * pageSize, currentPage * pageSize)"
                                stripe
                                :header-cell-style="{
                                    background: '#F0F3F6',
                                    color: '#626262',
                                    fontSize: '14px',
                                    fontFamily: 'ArialMT',
                                    paddingTop: '17px',
                                    paddingBottom: '15px',
                                    paddingLeft:'20px'
                                }"
                                :cell-style="columnStyle"
                                style="width: 100%"
                                >
                                    <!-- 空状态 -->
                                    <template slot="empty">
                                        <p style="margin-top: 50px">
                                        <img
                                            class="data-pic"
                                            src="../../assets/img/noData.png"
                                            alt=""
                                        />
                                        </p>
                                        <p class="nodata">No Data</p>
                                    </template>
                                    <el-table-column prop="orderId"  :label="$t('exchange.OrderID')">
                                    </el-table-column>
                                    <el-table-column prop="date" :label="$t('exchange.Time')">
                                    </el-table-column>
                                    <el-table-column prop="symbol" :label="$t('exchange.Symbol')">
                                    </el-table-column>
                                    <el-table-column prop="order" :label="$t('exchange.Order')">
                                        <template slot-scope="scope">
                                            <div :class="scope.row.order == 'BUY' ? 'buy_btn_txt' : 'sell_btn_txt'">{{scope.row.order}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="amount" :label="$t('exchange.Amount')">
                                        <template slot-scope="scope">
                                            {{addComma(scope.row.amount)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="balance" :label="$t('exchange.Balance')">
                                        <template slot-scope="scope">
                                            {{addComma(scope.row.balance)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="price" :label="$t('exchange.Price')">
                                        <template slot-scope="scope">
                                            ${{addComma(scope.row.price)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ordertype" :label="$t('exchange.OrderType')">
                                    </el-table-column>
                                    <el-table-column prop="total" :label="$t('exchange.Total')">
                                        <template slot-scope="scope">
                                            ${{addComma(scope.row.total)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="status" :label="$t('exchange.Status')">
                                    </el-table-column>
                                </el-table>
                                <div class="display_flex dis_end" style="margin-top: 47px">
                                    <el-pagination
                                        v-if="orderHistoryList.length != 0"
                                        @current-change="handleCurrentChange"
                                        :page-size="pageSize"
                                        background
                                        layout="prev, pager, next"
                                        class="pagination"
                                        prev-text="<"
                                        next-text=">"
                                        :total="orderHistoryList.length"
                                    >
                                    </el-pagination>
                                </div>
                        </div>
                    </div>

                    <!-- TradeHistory列表 -->
                    <div v-if="currentActiveName == '3'">
                        <div class="">
                            <el-table :data="traderHistoryList.slice( (currentPage - 1) * pageSize, currentPage * pageSize)"
                                stripe
                                :header-cell-style="{
                                    background: '#F0F3F6',
                                    color: '#626262',
                                    fontSize: '14px',
                                    fontFamily: 'ArialMT',
                                    paddingTop: '17px',
                                    paddingBottom: '15px',
                                    paddingLeft:'20px'
                                }"
                                :cell-style="columnStyle"
                                style="width: 100%"
                                >
                                    <!-- 空状态 -->
                                    <template slot="empty">
                                        <p style="margin-top: 50px">
                                        <img
                                            class="data-pic"
                                            src="../../assets/img/noData.png"
                                            alt=""
                                        />
                                        </p>
                                        <p class="nodata">No Data</p>
                                    </template>
                                    <el-table-column prop="orderId"  :label="$t('exchange.OrderID')">
                                    </el-table-column>
                                    <el-table-column prop="date" :label="$t('exchange.Time')">
                                    </el-table-column>
                                    <el-table-column prop="symbol" :label="$t('exchange.Symbol')">
                                    </el-table-column>
                                    <el-table-column prop="order" :label="$t('exchange.Order')">
                                        <template slot-scope="scope">
                                            <div :class="scope.row.order == 'BUY' ? 'buy_btn_txt' : 'sell_btn_txt'">{{scope.row.order}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="amount" :label="$t('exchange.Amount')">
                                        <template slot-scope="scope">
                                            {{addComma(scope.row.amount)}}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="creditingPeriod" :label="$t('exchange.trader_Price')">
                                    </el-table-column> -->
                                    <el-table-column prop="price" :label="$t('exchange.Price')">
                                        <template slot-scope="scope">
                                            ${{addComma(scope.row.price)}}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="projectStatus" :label="$t('exchange.OrderType')">
                                    </el-table-column> -->
                                    <el-table-column prop="total" :label="$t('exchange.Total')">
                                        <template slot-scope="scope">
                                            ${{addComma(scope.row.total)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="status" :label="$t('exchange.Status')">
                                    </el-table-column>
                                    <el-table-column prop="fee" :label="$t('exchange.Fee')">
                                        <template slot-scope="scope">
                                            ${{addComma(scope.row.fee)}}
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="display_flex dis_end" style="margin-top: 47px">
                                    <el-pagination
                                        v-if="traderHistoryList.length != 0"
                                        @current-change="handleCurrentChange"
                                        :page-size="pageSize"
                                        background
                                        layout="prev, pager, next"
                                        class="pagination"
                                        prev-text="<"
                                        next-text=">"
                                        :total="traderHistoryList.length"
                                    >
                                    </el-pagination>
                                </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- buyCnt弹窗 -->
        <el-dialog :title="$t('exchange.OrderConfirmation')" :close-on-click-modal="false" :visible.sync="dialogbool" width="506px" center>
            <!-- <el-divider></el-divider> -->
            <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
                <el-col class="textone">{{$t("exchange.Order")}}</el-col>
                <el-col class="texttwo" :class="btntype == 'buy' ? 'buy_btn_txt' : 'sell_btn_txt'">{{btntype == 'buy' ? 'Buy' : 'Sell'}}</el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
                <el-col class="textone">{{$t("exchange.Amount")}}</el-col>
                <el-col class="texttwo">{{btntype == 'buy' ? buyAmount : sellAmount}}<span class="span_box_txt"> CNT</span></el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
                <el-col class="textone">{{$t("exchange.LimitPrice")}}</el-col>
                <el-col class="texttwo">US{{btntype == 'buy' ? buyPrice : sellPrice}}</el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
                <el-col class="textone">{{$t("exchange.OrderType")}}</el-col>
                <el-col class="texttwo">{{orderType == '1' ? 'Limit Order' : 'Market Order'}}</el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
                <el-col class="textone">{{$t("exchange.TotalPrice")}}</el-col>
                <el-col class="texttwo">US${{limitPriceAmount}}</el-col>
            </el-row>
            <div @click="cleardialog()" :class="btntype == 'sell' ? 'sell_btn_dia' : ''" class="btn_box_mg_dia">{{$t('exchange.Confirm')}}</div>
        </el-dialog>
        <!-- submit成功弹窗 -->
        <el-dialog title="" :append-to-body='true' :close-on-click-modal="false" :visible.sync="submitbool" width="450px" center>
            <div style="text-align:center;margin-bottom:16px">
                <img  src="../../assets/img/duihao.png" alt="">
            </div>
            <div class="dialog_titles">Transaction Success</div>
        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import { formatDate, formatDateTime } from "@/util/date";
import carbonRegistry from "@/api/carbonRegistry.js";
export default {
  name: 'exchange',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
        exchangeTab:1,
        currentActiveName:'1',
        login:'',
        btntype:'buy',
        amount:'',
        limitPrice:'',
        limitPriceAmount:'--',
        orderType:'1',
        checked:false,
        dialogbool:false,
        buyPrice:'--',
        buyAmount:'--',
        sellPrice:'--',
        sellAmount:'--',
        orderHistoryList:[
            {
                orderId:'202204090000000001',
                date:'2022-04-09 11:49:32',
                symbol:'CNT',
                order:'BUY',
                amount:'12.45',
                balance:'0',
                price:'1234.56',
                ordertype:'Limit',
                total:'15370.27',
                status:'Matched',
            },
            {
                orderId:'202204090000000005',
                date:'2022-04-09 15:05:16',
                symbol:'CNT',
                order:'BUY',
                amount:'22.34',
                balance:'11.34',
                price:'1000.00',
                ordertype:'Limit',
                total:'22340.00',
                status:'Open',
            },
            {
                orderId:'2022040900000000056',
                date:'2022-04-09 16:13:14',
                symbol:'CNT',
                order:'SELL',
                amount:'10.00',
                balance:'10.00',
                price:'2000.00',
                ordertype:'Limit',
                total:'20000.00',
                status:'Open',
            },
        ],
        traderHistoryList:[
            {
                orderId:'202204090000000001',
                date:'2022-04-09 11:49:32',
                symbol:'CNT',
                order:'BUY',
                amount:'12.45',
                price:'1234.56',
                total:'15370.27',
                status:'Matched',
                fee:'38.43'
            },
            {
                orderId:'202204090000000005',
                date:'2022-04-09 11:55:00',
                symbol:'CNT',
                order:'SELL',
                amount:'10.00',
                price:'1234.56',
                total:'10000.00',
                status:'Matched',
                fee:'25.00'
            },
        ],
        pageSize: 10,
        currentPage: 1,
        orderTypeList:[
            {
                value:'1',
                label:'Limit'
            },
            {
                value:'2',
                label:'Market'
            },
        ],
        submitbool:false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
        amount:function(val){
            //计算总值
            this.limitPriceAmount = parseFloat(val * (this.limitPrice ? this.limitPrice : 1)).toFixed(2)
            if(this.btntype == 'buy'){
                this.buyAmount = val ? val : '--'
            }else{
                this.sellAmount = val ? val : '--'
            }
        },
        limitPrice:function(val){
            //计算总值
            this.limitPriceAmount = parseFloat(val * (this.amount ? this.amount : 1)).toFixed(2)
            if(this.btntype == 'buy'){
                this.buyPrice = val ? '$' + val : '--'
            }else{
                this.sellPrice = val ? '$' + val : '--'
            }
        },
        btntype:function(val){
            
            // this.sellPrice = 0
            // this.sellAmount = 0
            // this.buyPrice = 0
            // this.buyAmount = 0
            this.amount = ''
            this.limitPrice = ''
            this.limitPriceAmount = '--'
            this.checked = false
            console.log(this.sellPrice)
        },
  },
  // 方法集合
  methods: {
        formatDate: formatDate,
        handleChange(val){
            console.log(val)
            this.currentActiveName = val;
        },
        //翻页
        handleCurrentChange(updateCurrentPage) {
            this.currentPage = updateCurrentPage;
        },
        columnStyle({ row, column, rowIndex, columnIndex}){
            if(columnIndex == 1){
                return "color:#366F67;word-break:break-word;padding-left:20px";
            }
            return "word-break:break-word;padding-left:20px";
        },
        //切换买卖
        buyorsell(val){
            this.btntype = val
            if(val == 'buy'){
                this.sellPrice = '--'
                this.sellAmount = '--'
            }
            if(val == 'sell'){
                this.buyPrice = '--'
                this.buyAmount = '--'
            }
        },
        // 定义添加逗号的方法
        addComma(num = 0) {
            return num.toString().replace(/\d+/, function(n) {
                return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            });
        },
        submitBuyCnt(){
            if(!this.checked){
                this.dialogbool = true
            }else{
                this.submitbool = true
            }
            
        },
        cleardialog(){
            this.dialogbool = false
            setTimeout(()=>{
                this.submitbool = true
            },500)
            
        }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
        let that = this;
        that.login = JSON.parse(sessionStorage.getItem('login'))
        if(that.login){
        }
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  
}
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
::v-deep .overview_wrap{
    background: #f8f9fa;
    padding: 45px;
    border-radius: 10px;
    .mg_top{
        margin-top: 40px;
        .btn_box_mg{
            height: 44px;
            background: #158869;
            border-radius: 4px;
            font-size: 14px;
            font-family: ArialMT;
            color: #FFFFFF;
            line-height: 44px;
            padding: 0 20px;
            text-align: center;
            cursor: pointer;
        }
        .sell_btn{
            // border-radius: 0px 4px 4px 0px;
            background: #DC5F5F;
            color: #FFFFFF;
        }
    }
    .carbon_box{
        .green_text{
            color: #158869 !important;
        }
        .red_text{
            color: #DC5F5F !important;
        }
        .carbon_box_title{
            font-size: 14px;
            font-family: Arial-BoldMT, Arial;
            font-weight: 600;
            color: #21212B;
            line-height: 16px;
        }
        .carbon_box_ipt{
            // width: 220px;
            height: 48px;
            background: #FFFFFF;
            border-radius: 4px;
            font-size: 16px;
            font-family: ArialMT;
            color: #626262;
            line-height: 48px;
            padding: 0 15px;
            margin-top: 8px;
            cursor: pointer;
        }
        .carbon_btn{
            margin-top: 10px;
            display: flex;
            align-items: center;
            position: relative;
            .btn_box{
                height: 38px;
                background: #FFFFFF;
                
                padding: 0 30px;
                font-size: 16px;
                font-family: ArialMT;
                color: #626262;
                line-height: 38px;
                cursor: pointer;
            }
            .buy_btn{
                background: #158869;
                border-radius: 4px 0px 0px 4px;
                color: #FFFFFF;
            }
            .sell_btn{
                border-radius: 0px 4px 4px 0px;
                background: #DC5F5F;
                color: #FFFFFF;
            }
            .ch_txt{
                // margin-left: 20px;
                position: absolute;
                right: -15px;
                top: 12px;
                font-size: 14px;
                font-family: Arial-BoldMT, Arial;
                font-weight: normal;
                color: #626262;
                line-height: 16px;
            }
        }
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus{
        border-color: #158869;
    }
    .el-checkbox__inner:hover{
        border-color: #158869;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color:#158869;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label{
        color: #158869;
    }
}
.aaa {
   ::v-deep .el-collapse-item__header {
    background-color: #158869 !important;
    color: #ffffff !important;
    border-radius: 10px !important;
    padding: 0 20px !important;
  }

}
.btn_box_mg_dia{
    margin: 20px auto 0 auto;
    width: 125px;
    height: 44px;
    background: #158869;
    border-radius: 4px;
    font-size: 14px;
    font-family: ArialMT;
    color: #FFFFFF;
    line-height: 44px;
    padding: 0 20px;
    text-align: center;
    cursor: pointer;
}
.sell_btn_dia{
    // border-radius: 0px 4px 4px 0px;
    background: #DC5F5F;
    color: #FFFFFF;
}
.sell_btn_txt{
    color: #DC5F5F !important;
}
.buy_btn_txt{
    color: #158869 !important;
}
.span_box_txt{
    font-size: 14px;
    font-family: ArialMT;
    color: #626262;
}
::v-deep .left .el-collapse-item__header.is-active {
  background-color: #158869;
  color: #ffffff;
  border-radius: 10px;
  padding: 0 12px;
}
::v-deep .left .el-collapse-item__content:first-child {
  padding: 0;
  border-bottom: none;
}
::v-deep .left .el-collapse-item__header {
  border: none;
  font-size: 14px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1e1e1e;
  line-height: normal;
  background-color: transparent;
  // color: #ffffff;
}
::v-deep .left .el-collapse {
  border-top: none;
  border-bottom: none;
}
::v-deep .el-dialog{
  margin-top: 40vh !important;
  // height: 311px;
  border-radius: 30px;
  .el-dialog__title{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
  }
  .el-divider--horizontal{
    margin-top: 0;
  }
  .dialog_title{
    padding-top: 10px;
    margin-bottom: 30px;
    text-align: center;
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
  }
  .dialog_titles{
    text-align: center;
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 23px;
  }
  .ipt_box{
    width: 460px;
    margin:0 auto
  }
  .dialog_flex{
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    .textone{
      font-size: 16px;
      font-family: ArialMT;
      color: #21212B;
      line-height: 23px;
      text-align: left;
      font-weight: 600;
    }
    .texttwo{
      text-align: right;
      font-size: 16px;
      font-family: Arial-BoldMT, Arial;
      // font-weight: 600;
      color: #626262;
      line-height: 26px;
    }
  }
  .el-icon-close:before{
    content: url('../../assets/img/guanbi.png');
  }
}
</style>
